import { render, staticRenderFns } from "./EditorSectionsManagementTab_SectionCard.vue?vue&type=template&id=f4f2aec0"
import script from "./EditorSectionsManagementTab_SectionCard.vue?vue&type=script&lang=ts"
export * from "./EditorSectionsManagementTab_SectionCard.vue?vue&type=script&lang=ts"
import style0 from "./EditorSectionsManagementTab_SectionCard.vue?vue&type=style&index=0&id=f4f2aec0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports